"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var ViewFactory_1 = require("./ViewFactory");
var HSplit_styles_1 = require("./HSplit.styles");
var HSplit_classNames_1 = require("./HSplit.classNames");
var utilities_1 = require("@uifabric/utilities");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var HSplit = /** @class */ (function (_super) {
    __extends(HSplit, _super);
    function HSplit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onDocumentMouseUp = function (e) {
            _this._ref.ownerDocument.removeEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.removeEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.hsplit.setSplitActive(false);
        };
        _this._onDocumentMouseMove = function (e) {
            e.preventDefault();
            _this._resize(e);
        };
        _this._onSplitterMouseDown = function (e) {
            e.preventDefault();
            _this._ref.ownerDocument.addEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.addEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.hsplit.setSplitActive(true);
        };
        _this._onRef = function (ref) {
            _this._ref = ref;
        };
        _this._onSplitterRef = function (ref) {
            _this._splitterRef = ref;
        };
        return _this;
    }
    HSplit.prototype._resize = function (e) {
        var minItemWidth = this.props.hsplit.minItemWidth;
        var bounds = this._ref.getBoundingClientRect();
        var splitterBounds = this._splitterRef.getBoundingClientRect();
        var max = bounds.width - splitterBounds.width - minItemWidth;
        var splitterPos = e.clientX - bounds.left;
        if (splitterPos <= minItemWidth) {
            splitterPos = minItemWidth;
        }
        else if (splitterPos >= max) {
            splitterPos = max;
        }
        var offset = splitterPos / bounds.width;
        this.props.hsplit.setOffset(offset);
    };
    HSplit.prototype.render = function () {
        var _a = this.props, hsplit = _a.hsplit, styles = _a.styles, className = _a.className;
        var classNames = HSplit_classNames_1.getClassNames(HSplit_styles_1.getStyles(null, styles), className);
        var leftContent = ViewFactory_1.ViewFactory(hsplit.left);
        var rightContent = ViewFactory_1.ViewFactory(hsplit.right);
        return (React.createElement("div", { className: classNames.root, ref: this._onRef },
            React.createElement("div", { className: classNames.leftPane, style: { width: hsplit.leftWidth } },
                React.createElement("div", { className: classNames.leftContent }, leftContent)),
            React.createElement("div", { className: utilities_1.css(classNames.splitter, { active: hsplit.splitActive }), onMouseDown: this._onSplitterMouseDown, style: { left: hsplit.leftWidth, width: hsplit.splitterWidth }, ref: this._onSplitterRef },
                React.createElement("div", { className: utilities_1.css(classNames.splitterHandle, { active: hsplit.splitActive }) },
                    React.createElement(Icon_1.Icon, { iconName: "GripperBarVertical", className: "hsplit-icon" }))),
            React.createElement("div", { className: classNames.rightPane, style: { left: hsplit.leftWidth + hsplit.splitterWidth, width: hsplit.rightWidth } },
                React.createElement("div", { className: classNames.rightContent }, rightContent))));
    };
    HSplit = __decorate([
        mobx_react_1.observer
    ], HSplit);
    return HSplit;
}(React.Component));
exports.HSplit = HSplit;
